import React from "react";
import { Pressable, StyleSheet, Text, View } from "react-native";
import * as Haptics from "expo-haptics";
import { useRouter } from "expo-router";

import ProfileGrid from "./Authentication/Components/ProfileGrid/ProfileGrid";

import GradientButton from "@/Components/Buttons/StartHere";
import AuthLayout from "@/Components/Layouts/Native/AuthLayout";
import { themes } from "@/Components/Styling/themeConfigs";

function LandingScreen(): React.JSX.Element {
  const currentTheme = themes.morning;
  const router = useRouter();

  const signUpOnPress = (): void => {
    void Haptics.impactAsync(Haptics.ImpactFeedbackStyle.Medium);
    router.push("/(authentication)/sign-up");
  };

  const loginOnPress = (): void => {
    void Haptics.impactAsync(Haptics.ImpactFeedbackStyle.Light);
    router.push("/(authentication)/sign-in");
  };

  return (
    <AuthLayout hideFooter={true}>
      <ProfileGrid />
      <View testID="landing-join-now-button" style={styles.buttonContainer}>
        <GradientButton text="Join Now" onPress={signUpOnPress} />
      </View>
      <Pressable onPress={loginOnPress}>
        <Text
          testID="landing-sign-in-button"
          style={[styles.linkText, { color: currentTheme.link }]}
        >
          Sign in
        </Text>
      </Pressable>
    </AuthLayout>
  );
}

const styles = StyleSheet.create({
  buttonContainer: {
    marginBottom: 15,
  },
  linkText: {
    fontSize: 20,
    fontWeight: "600",
    textAlign: "center",
  },
});

export default LandingScreen;
